import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as firebase from 'firebase';
import 'firebase/firestore';
import {ToastService} from '../typescripts/pro/alerts'

@Component({
  selector: 'app-adminnoticias-crear',
  templateUrl: './adminnoticias-crear.component.html',
  styleUrls: ['./adminnoticias-crear.component.scss']
})
export class AdminnoticiasCrearComponent implements OnInit {
  state = 'crear';
  objectId;
  user;
  userId;
  ampa;
  titulo;
  descripcion;
  fecha;
  imagen = 'https://firebasestorage.googleapis.com/v0/b/miampa-1be3e.appspot.com/o/compartido%2Fdefault-image.png?alt=media&token=1486414d-b17d-4789-a148-11c226f96c20';
  selectedfilename;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastService
  ) {
    this.fecha = new Date();
    this.state = 'crear';
    this.route.params.subscribe(params => {
      if(params.state){
        if(params.state === 'editar'){
          this.state = 'editar';
          this.objectId = params.id
        } else if(params.state === 'ver'){
          this.state = 'ver';
          this.objectId = params.id
        }
        else
          this.state = 'crear';

        this.cargarDatos(this.objectId)
      }
      console.log('params state: ', this.state)
      console.log('params state: ', params.state)
      console.log('params id: ', params.id)
    })

    //obtener datos del usuario admin logueado
    this.userId = localStorage.getItem('userId');
    console.log('UserId', this.userId);
    if(!this.userId){
      this.router.navigate[('')]
    } else {
      firebase.firestore().collection('admins').doc(this.userId)
      .get()
      .then((doc)=>{
        this.user = doc.data();
        


      })
    }
  }

  ngOnInit() {}

  //guardar los datos del elemento creado
  guardar(){
    firebase.firestore().collection('noticias').add({
      ampa: this.user.ampa || '',
      titulo: this.titulo || '',
      descripcion: this.descripcion || '',
      fecha: this.fecha || '',
      imagen: this.imagen || '',
    })
    .then((docRef)=>{
      if (docRef)
        console.log('Creado ', docRef.id)
      this.showSuccess('Datos guardatos correctamente.');
      this.router.navigate(['/admin/noticias'])
    })
    .catch(err => {
        console.log('Error getting documents', err);
    });
  }
  cargarDatos(id){
    firebase.firestore().collection('noticias').doc(id)
    .get()
    .then((doc)=>{
      var elemento = doc.data();
      this.titulo = elemento.titulo;
      this.descripcion = elemento.descripcion;
      this.fecha = new Date(elemento.fecha);

      this.imagen = elemento.imagen;
      
    })
  }

  volver(){
    this.router.navigate(['/admin/noticias'])

  }
  editar(){
    firebase.firestore().collection('noticias').doc(this.objectId).update({
      ampa: this.user.ampa || '',
      titulo: this.titulo || '',
      descripcion: this.descripcion || '',
      fecha: this.fecha || '',
      imagen: this.imagen || '',
    })
    .then((docRef)=>{
      if (docRef)
        console.log('Creado ', docRef);
      this.showSuccess('Datos guardatos correctamente.');
      this.router.navigate(['/admin/noticias']);
    })
  }

  setFocus($event) {
    $event.focus();
  }

  selectedFile(fileInput: Event){

    let target = <HTMLInputElement>fileInput.target;
    let files = target.files;
    let file = files.item(0);

    var storage = firebase.storage();
    var storageRef = storage.ref();

    var imagesRef = storageRef.child('ampas/'+ this.user.ampa + '/' + file.name );
    this.selectedfilename = file.name;
    imagesRef.put(file)
    .then((snapshot)=>{
      this.imagen = snapshot.downloadURL;
    })
  }

  //metodos de toast para el usuario
  showSuccess(mensaje) {
    //let options = { closeButton: true, tapToDismiss: false,  titleClass: 'yellow' };
    //this.toast.success(mensaje, 'Toastr success!', options);
    this.toast.success(mensaje);
  }

  showError(mensaje) {
    //let options = { enableHtml: false,  positionClass: 'toast-bottom-right' };
    //this.toast.error(mensaje, 'Toastr error!', options);
    this.toast.error(mensaje);
  }

  showInfo(mensaje) {
    //let options = { extendedTimeOut: 30000, messageClass: 'pink' };
    //this.toast.info('Info message', 'Toastr info!', options);
    this.toast.info(mensaje);
  }

  showWarning(mensaje) {
    //let options = { progressBar: true,  timeOut: 3000,  toastClass: 'black'};
    //this.toast.warning('Warnig message', 'Toastr warning!', options);
    this.toast.warning(mensaje);
  }

}





// WEBPACK FOOTER //
// ./src/app/adminnoticias-crear/adminnoticias-crear.component.ts